export default function (address) {
    let addressText = (address.shopNumber ? 'Unit ' + address.shopNumber + ', ' : '')  + (address.street ? address.street : '') + (address.suburb ? ', ' + address.suburb : '') + (address.state ? ', ' + address.state : '') + (address.postcode ? ' ' + address.postcode : '') + (address.country ? ', ' + address.country : '')
    return addressText;
}